import { Stack } from "@mui/material";

import {
  EmbeddedAnalyticsPage,
  EmbeddedDashboard,
} from "components/EmbeddedAnalytics";
import { EmbeddedDashboardName } from "components/EmbeddedAnalytics/types";
import { ErrorTypography } from "components/ErrorTypography";
import {
  useEmbeddedAnalyticsAccess,
  useIsDemoParticipant,
  useSubscriptionStatus,
} from "hooks";
import { subscriptionRequiresUpgradeToAccessAnalytics } from "utils";

import { AnalyticsPackageUnactivatedPage } from "../AnalyticsPackageUnactivatedPage";
import { AnalyticsUpgradePage } from "../AnalyticsUpgradePage";

export function DataPageWrapper() {
  /*
  Renders the howdygo demo to subscriptions that do not have a data package in their sub,
  However, some users may have the data package turned on
  (even if their subscription does not allow it - e.g. if sales/operations is giving them a demo
  with the 'real' data product)
  */
  const isDemoParticipant = useIsDemoParticipant();
  const { subscription } = useSubscriptionStatus();
  const { hasAccess, error } = useEmbeddedAnalyticsAccess({
    dashboard: EmbeddedDashboardName.COMPANY_DASHBOARD,
  });

  // Demo participants always see the HowdyGo walkthrough, regardless of their
  // (typically absent) subscription/analytics access.
  if (isDemoParticipant) {
    return <AnalyticsPackageUnactivatedPage isDemoParticipant />;
  }

  if (subscription === null) {
    return null;
  }

  if (hasAccess == null) {
    if (error !== null) {
      return (
        <Stack>
          <ErrorTypography error={error} />
        </Stack>
      );
    }
    return null;
  }

  if (!hasAccess) {
    // Order matters: the upgrade prompt is only right for plans that do not
    // include analytics at all. A company whose plan covers it but has not had
    // it switched on is told to upgrade to something they already pay for.
    // These were the other way round, which made the upgrade page unreachable.
    return subscriptionRequiresUpgradeToAccessAnalytics(subscription) ? (
      <AnalyticsUpgradePage />
    ) : (
      <AnalyticsPackageUnactivatedPage />
    );
  }

  return (
    <EmbeddedAnalyticsPage
      dashboard={
        <EmbeddedDashboard
          dashboard={EmbeddedDashboardName.COMPANY_DASHBOARD}
        />
      }
    />
  );
}
